module.exports = __webpack_public_path__ + "static/media/main--3.b7ce0dde.png";